import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, isRef as _isRef, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "fv-plugins-message-container" }
const _hoisted_17 = { class: "fv-help-block" }
const _hoisted_18 = { class: "row mb-6" }
const _hoisted_19 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_20 = { class: "col-lg-8 fv-row" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "fv-plugins-message-container" }
const _hoisted_23 = { class: "fv-help-block" }
const _hoisted_24 = { class: "row mb-6" }
const _hoisted_25 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_26 = { class: "col-lg-8 fv-row" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "fv-plugins-message-container" }
const _hoisted_29 = { class: "fv-help-block" }

import { showBackendError } from "@/assets/ts/_utils/ShowBackendError";
//import comarcas from "@/core/data/comarcas";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import Page from "@/layout/Page.vue";
import { OrganismosModule, UsuariosListadoModule } from "@/store/modules";
import { ArrowDown } from "@element-plus/icons-vue";
import { ElMessage, ElNotification } from "element-plus";
import Swal from "sweetalert2";
import { ErrorMessage, useField, useForm } from "vee-validate";
import { computed, onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { getModule } from "vuex-module-decorators";
import * as Yup from "yup";

interface FormState {
  nombre: string;
  email: string;
  comarcaId: string;
  notificaciones: boolean;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n();
const store = useStore();
const module = getModule(UsuariosListadoModule, store);
const moduleOrganismos = getModule(OrganismosModule, store);
const usuario = computed(() => module.usuario);
const comarcas = computed(() => moduleOrganismos.organismosListado);

const router = useRouter();
const route = useRoute();
const token = computed(() =>
  route.params.id ? (route.params.id as string) : null
);
const isCreate = computed(() => !token.value);

const schema = Yup.object({
  nombre: Yup.string()
    .required()
    .label(t("formularios.personalDetalle.nombre.label")),
  email: Yup.string()
    .email()
    .required()
    .label(t("formularios.personalDetalle.email.label")),
  comarcaId: Yup.string()
    .required()
    .label(t("formularios.personalDetalle.comarca.label")),
  notificaciones: Yup.boolean()
    .required()
    .label(t("formularios.personalDetalle.notificaciones.label")),
});

const { resetForm, handleSubmit } = useForm<FormState>({
  validationSchema: schema,
});
const { value: nombre } = useField("nombre");
const { value: email } = useField("email");
const { value: comarcaId } = useField("comarcaId");
const { value: notificaciones } = useField("notificaciones");

const cargaDetalle = ref<boolean>(false);
const fetch = async function (id) {
  cargaDetalle.value = true;
  if (id) {
    await module.fetchById(id).catch((err) => {
      if (typeof err === "object" && err?.error?.statusCode < 500) {
        showBackendError(t, err.error);
      } else {
        Swal.fire({
          text: t("formularios.menor.cargar.error"),
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: t("dialogs.okButton"),
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });
      }
    });
  }
  await moduleOrganismos.fetchAll();
  cargaDetalle.value = false;
};

watch(usuario, () => {
  if (!usuario.value) return;

  resetForm({
    values: {
      nombre: usuario.value.nombre,
      email: usuario.value.email,
      comarcaId: usuario.value.comarcas?.length
        ? usuario.value.comarcas[0].id
        : "",
      notificaciones: usuario.value.notificaciones,
    },
  });

  setCurrentPageBreadcrumbs(usuario.value.nombre, [
    t("menu.usuarios"),
    { title: t("menu.usuariosListado"), path: "/listados/personal" },
  ]);
});

onMounted(() => {
  fetch(token.value);

  setCurrentPageBreadcrumbs(t("menu.nuevo"), [
    t("menu.usuarios"),
    { title: t("menu.usuariosListado"), path: "/listados/personal" },
  ]);

  resetForm({
    values: {
      nombre: "",
      email: "",
      comarcaId: "",
      notificaciones: true,
    },
  });
});

const crearUsuario = async (values) => {
  try {
    await module.crear({
      ...values,
      username: values.email,
    });
    await ElNotification({
      message: t("formularios.personal.crear.mensaje.exito"),
      type: "success",
    });
    router.replace("/listados/personal");
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    if (typeof err === "object" && err?.error?.statusCode < 500) {
      return showBackendError(t, err.error);
    }

    ElNotification({
      message: t("formularios.personal.crear.mensaje.error"),
      type: "error",
    });
  }
};

const updateUsuario = async (id, values) => {
  try {
    await module.updateById({
      id,
      usuario: {
        nombre: values.nombre,
        email: values.email,
        notificaciones: values.notificaciones,
      },
    });
    ElNotification({
      message: t("formularios.personal.guardar.mensaje.exito"),
      type: "success",
    });
    return router.replace("/listados/personal");
  } catch (err) {
    ElNotification({
      message: t("formularios.personal.guardar.mensaje.error"),
      type: "error",
    });
  }
};

const submit = handleSubmit(async (values) => {
  if (isCreate.value) {
    return crearUsuario(values);
  }

  return updateUsuario(token.value, values);
});

const eliminar = async () => {
  if (!token.value) return;

  const { isConfirmed } = await Swal.fire({
    text: t("dialogs.eliminar.confirmacion"),
    icon: "question",
    showCancelButton: true,
    confirmButtonText: t("dialogs.okButton"),
    cancelButtonText: t("dialogs.cancelButton"),
    reverseButtons: true,
  });

  if (!isConfirmed) return;

  try {
    await module.deleteById(token.value);
    ElMessage({
      message: t("dialogs.eliminar.exito"),
      type: "success",
    });
    router.replace("/listados/personal");
  } catch (err) {
    Swal.fire({
      text: t("dialogs.eliminar.error"),
      icon: "error",
      buttonsStyling: false,
      confirmButtonText: t("dialogs.okButton"),
      customClass: { confirmButton: "btn btn-primary" },
    });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(Page, { showBack: "" }, {
    actions: _withCtx(() => [
      (!_unref(isCreate))
        ? (_openBlock(), _createBlock(_component_el_dropdown, {
            key: 0,
            class: "mx-3"
          }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_dropdown_item, { onClick: eliminar }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("page.acciones.eliminar")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_button, { type: "default" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("formularios.servicioDetalle.acciones.button")) + " ", 1),
                  _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ArrowDown))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _unref(submit)
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(isCreate) ? _ctx.$t("page.acciones.crear") : _ctx.$t("page.acciones.guardar")), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_el_tabs, {
        type: "border-card",
        modelValue: "datosMenor"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            name: "datosMenor",
            label: _ctx.$t('formularios.personal.label')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t("formularios.personal.label")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("formularios.personalDetalle.ubicacion.label")), 1),
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(comarcaId),
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(comarcaId) ? (comarcaId).value = $event : null)),
                          class: "w-100",
                          disabled: !_unref(isCreate)
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(comarcas), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.nombreCompuesto,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"]),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_unref(ErrorMessage), { name: "comarcaId" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("formularios.personalDetalle.nombre.label")), 1),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_el_input, {
                            type: "text",
                            name: "nombre",
                            placeholder: " ",
                            modelValue: _unref(nombre),
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(nombre) ? (nombre).value = $event : null))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                              _createVNode(_unref(ErrorMessage), { name: "nombre" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("formularios.personalDetalle.email.label")), 1),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(_component_el_input, {
                            type: "text",
                            name: "email",
                            placeholder: " ",
                            modelValue: _unref(email),
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(email) ? (email).value = $event : null))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _createVNode(_unref(ErrorMessage), { name: "email" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t("formularios.personalDetalle.notificaciones.label")), 1),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createVNode(_component_el_switch, {
                            modelValue: _unref(notificaciones),
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(notificaciones) ? (notificaciones).value = $event : null))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _createVNode(_unref(ErrorMessage), { name: "notificaciones" })
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      })), [
        [_directive_loading, cargaDetalle.value]
      ])
    ]),
    _: 1
  }))
}
}

})